import { atom } from "recoil"

const fullscreenViewAtom = atom<{fullscreen: boolean, immersive: boolean}>({
  key: "fullScreenViewAtom",
  default: { fullscreen: false, immersive: false }
})

export default fullscreenViewAtom;
